import React from 'react'
import FormHOC from './FormHOC'
import InputRow from '../elements/InputRow'
import Button from '../elements/Button'
import { ACTION_ADD, ACTION_MODIFY, ACTION_DELETE, mapTitleFields } from '../constants'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'

const handleClick = event => {
    event.preventDefault()
    window.location.reload()
}

const options = {
    postUrl: '/api/postAuthorisedContact',
    success: <React.Fragment>
        <p>Success! Your authorised contact details have been successfully updated.</p>
        <p><a href='#' onClick={handleClick} className='color-indigo'>Return to form</a></p>
    </React.Fragment>
}
const state = {}

const AuthorisedContactForm = (props) => {

    const handleSubmit = (event, action) => {
       props.setDynamicValues({
           action: action,
           contactId: props.values.id
       })
       props.handleSubmit(event)
    }

    const handleKeyDown = (event) => {
        if (event.keyCode === 13) {
            handleSubmit(event, ACTION_ADD)
        }
    }

    const SubmitBtn = () => {
        if (props.isModifyOrAdd() === ACTION_MODIFY) {
            return (
                <div className='row'>
                    <div className='col-12 col-lg-6 mb-3 mb-lg-0'>
                        <Button title='Update Details' action={event => handleSubmit(event, ACTION_MODIFY)} />
                    </div>
                    <div className='col-12 col-lg-6 text-lg-right'>
                        <Button title='Delete Contact' action={event => handleSubmit(event, ACTION_DELETE)} className='text-center color-red' />
                    </div>
                </div>
            )
        }

        return <Button title='Add Contact' action={event => handleSubmit(event, ACTION_ADD)} />
    }

    return (
        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
            <FancySelectAdvancedRow
                label='Title'
                name='title'
                value={props.values.title}
                errors={props.errors}
                options={mapTitleFields}
                handleChange={props.setDynamicValues}
            />
            <InputRow
                label='First Name'
                name='firstName'
                value={props.values.firstName}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Last Name'
                name='lastName'
                value={props.values.lastName}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Phone'
                name='phone'
                value={props.values.phone}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Mobile'
                name='mobile'
                value={props.values.mobile}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />
            <InputRow
                label='Email Address'
                name='email'
                value={props.values.email}
                errors={props.errors}
                handleChange={props.handleInputChange}
            />

            {props.children}

            <div className='mt-4 text-center text-lg-left'>
                { SubmitBtn() }
            </div>
        </form>
    )
}

export default FormHOC(AuthorisedContactForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/AuthorisedContactForm.js